/**
Project: Voice Panel (c)
Title: User Reducer
Description: Reducer for the user page
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import {
  USERS_ROUTING_POLICIES,
  USERS_ALL_RECORDS,
  USERS_UPDATE_RECORDS,
  USER_PHONE_NUMBER_TO_ALTER,
  USER_ROUTING_POLICY_TO_ALTER,
  ALTER_USER_PHONE_NUMBER,
  ALTER_USER_ROUTING_POLICY,
  ALTER_USER_CHECKBOX_STATUS,
  USERS_DATA_RESET,
} from "./constants";

const INIT_STATE = {
  usersRoutingPolicies: [],
  usersAllRecords: [],
  usersDisplayRecords: [],
  usersPageRecords: [],
  userPhoneNumberToAlter: "",
  userRoutingPolicyToAlter: "",
};

/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case USERS_ROUTING_POLICIES:
      return {
        ...state,
        usersRoutingPolicies: action.payload,
      };
    case USERS_ALL_RECORDS:
      return {
        ...state,
        usersAllRecords: [...action.payload],
      };
    case USER_PHONE_NUMBER_TO_ALTER:
      return {
        ...state,
        userPhoneNumberToAlter: action.payload,
      };
    case USER_ROUTING_POLICY_TO_ALTER:
      return {
        ...state,
        userRoutingPolicyToAlter: action.payload,
      };

    case ALTER_USER_PHONE_NUMBER:
      return {
        ...state,
        usersAllRecords: state.usersAllRecords.map((user) => {
          if (user.id === action.payload.id) {
            return Object.assign({}, user, {
              phone: action.payload.phone,
            });
          }
          return Object.assign({}, user, {});
        }),
      };

    case ALTER_USER_ROUTING_POLICY:
      return {
        ...state,
        usersAllRecords: state.usersAllRecords.map((user) => {
          if (user.id === action.payload.id) {
            return Object.assign({}, user, {
              policyId: action.payload.policyId,
            });
          }
          return Object.assign({}, user, {});
        }),
      };

    case ALTER_USER_CHECKBOX_STATUS:
      return {
        ...state,
        usersAllRecords: state.usersAllRecords.map((user) => {
          if (user.id === action.payload.id) {
            return Object.assign({}, user, {
              isSelected: action.payload.isSelected,
            });
          }
          return Object.assign({}, user, {});
        }),
      };
    case USERS_UPDATE_RECORDS:
      return {
        ...state,
        usersAllRecords: state.usersAllRecords.map((user) => {
          if (user.email === action.payload.email) {
            if (
              action.payload &&
              action.payload.actionType === "Remove" &&
              action.payload &&
              action.payload.paramName === "Phone"
            ) {
              return Object.assign({}, user, {
                phone: action.payload.paramValue,
                originalPhone: action.payload.paramValue,
              });
            } else if (
              action.payload &&
              action.payload.actionType === "Remove" &&
              action.payload &&
              action.payload.paramName === "Policy"
            ) {
              return Object.assign({}, user, {
                policyId: action.payload.paramValue,
                originalPolicyId: action.payload.paramValue,
              });
            } else if (
              action.payload &&
              action.payload.actionType === "Update" &&
              action.payload &&
              action.payload.paramName === "Phone"
            ) {
              return Object.assign({}, user, {
                phone: action.payload.paramValue,
                originalPhone: action.payload.paramValue,
              });
            } else if (
              action.payload &&
              action.payload.actionType === "Update" &&
              action.payload &&
              action.payload.paramName === "Policy"
            ) {
              return Object.assign({}, user, {
                policyId: action.payload.paramValue,
                originalPolicyId: action.payload.paramValue,
              });
            } else if (
              action.payload &&
              action.payload.actionType === "Import" &&
              action.payload &&
              action.payload.paramName === "Phone"
            ) {
              return Object.assign({}, user, {
                phone: action.payload.paramValue,
                originalPhone: action.payload.paramValue,
              });
            } else if (
              action.payload &&
              action.payload.actionType === "Import" &&
              action.payload &&
              action.payload.paramName === "Policy"
            ) {
              return Object.assign({}, user, {
                policyId: action.payload.paramValue,
                originalPolicyId: action.payload.paramValue,
              });
            }
          }
          return Object.assign({}, user, {});
        }),
      };
    case USERS_DATA_RESET:
      return INIT_STATE;

    default:
      return state;
  }
};
